import { Card, LazyLoader, Skeleton, Tab } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { TeachingBlocksTable } from '../../../components/Teachingblock/TeachingBlocksTable';
import { TimetableTable } from '../../../components/Timetable/TimetableTable';
import { TimetableBlock } from '../../../components/TimetableBlock/TimetableBlock';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { useUserConfigContext } from '../../../hooks/useUserConfigContext';
import styles from './TimetablePlanPage.module.scss';

export const TimetablePlanPage = observer(() => {
  const { t } = useTranslation();
  const schoolYear = useUserConfigContext().selectedSchoolYear;
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canReadTimetable()}
      className={styles['timetable-plan-page']}
      title={`${t('timetable.title', { count: 2 })} ${t('timetable.plan').toLowerCase()}`}
      hasOutlet
    >
      <Card
        wrapperClass={styles['timetable-block']}
        header={{
          headline: t('timetableBlock.selectedYear', {
            year: schoolYear?.name,
          }),
        }}
      >
        <TimetableBlock />
      </Card>
      <Tab
        className={styles['timetable-plan-tabs']}
        tabs={[
          {
            title: t('timetable.title', { count: 2 }),
            value: 'drafts',
            content: (
              <Suspense fallback={<LazyLoader embedded transparent forceHeight='30vh' />}>
                <TimetableTable />
              </Suspense>
            ),
          },
          {
            title: t('teachingBlock.title', { count: 2 }),
            value: 'teachingBlockDrafts',
            content: (
              <Suspense fallback={<LazyLoader embedded transparent forceHeight='30vh' />}>
                <TeachingBlocksTable />
              </Suspense>
            ),
          },
          {
            title: t('common.archive'),
            value: 'archive',
            content: <Skeleton />,
          },
        ]}
      />
    </Page>
  );
});
